import Vue from 'vue';
import {
  getArticleList,
  getArticleListByCategory,
  getArticle,
  getPortal,
  getCategories,
} from 'widget/api/helpCenter';

const state = {
  portal: {},
  articles: [],
  categoryArticles: [],
  categories: [],
  article: {},
  headerTitle: '',
  uiFlags: {
    isFetching: false,
  },
};

export const getters = {
  getPortal: $state => $state.portal,
  getArticles: $state => $state.articles,
  getCategoryArticles: $state => $state.categoryArticles,
  getCategories: $state => $state.categories,
  getArticle: $state => $state.article,
  getHeaderTitle: $state => $state.headerTitle,
  getIsFetching: $state => $state.uiFlags.isFetching,
};

export const actions = {
  fetchPortal: async ({ commit }, portalId) => {
    commit('setIsFetching', true);
    try {
      const { data } = await getPortal(portalId);
      commit('setPortal', data);
      commit('setIsFetching', false);
    } catch (error) {
      commit('setIsFetching', false);
    }
  },
  fetchArticleList: async ({ commit }, portalId) => {
    commit('setIsFetching', true);
    try {
      const { data } = await getArticleList(portalId);
      commit('setArticles', data);
      commit('setIsFetching', false);
    } catch (error) {
      commit('setIsFetching', false);
    }
  },
  fetchArticleListByCategory: async ({ commit }, { portalId, categoryId }) => {
    commit('setIsFetching', true);
    try {
      const { data } = await getArticleListByCategory(portalId, categoryId);
      commit('setCategoryArticles', data);
      commit('setIsFetching', false);
    } catch (error) {
      commit('setIsFetching', false);
    }
  },
  fetchArticle: async ({ commit }, { portalId, articleSlug }) => {
    commit('setIsFetching', true);
    try {
      const { data } = await getArticle(portalId, articleSlug);
      commit('setArticle', data);
      commit('setHeaderTitle', data.title);
      commit('setIsFetching', false);
    } catch (error) {
      commit('setIsFetching', false);
    }
  },
  fetchCategories: async ({ commit }, portalId) => {
    commit('setIsFetching', true);
    try {
      const { data } = await getCategories(portalId);
      commit('setCategories', data);
      commit('setIsFetching', false);
    } catch (error) {
      commit('setIsFetching', false);
    }
  },
  setHeaderTitle: ({ commit }, title) => {
    commit('setHeaderTitle', title);
  },
  resetArticle: ({ commit }) => {
    commit('resetArticle');
  },
};

export const mutations = {
  setPortal($state, portal) {
    $state.portal = portal;
  },
  setArticles($state, articles) {
    $state.articles = articles;
  },
  setCategoryArticles($state, categoryArticles) {
    $state.categoryArticles = categoryArticles;
  },
  setArticle($state, article) {
    $state.article = article;
  },
  setCategories($state, categories) {
    $state.categories = categories;
  },
  setHeaderTitle($state, title) {
    $state.headerTitle = title;
  },
  setIsFetching($state, value) {
    Vue.set($state.uiFlags, 'isFetching', value);
  },
  resetArticle($state) {
    $state.headerTitle = '';
    $state.article = {};
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
